import {ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {AbstractVisbosComponent} from '../../../../core/visbos-core/components/abstract-visbos.component';
import {SessionActions} from '../../../../shared/actions';
import {ActivatedRoute} from '@angular/router';
import {ApolloQueryObservable} from 'apollo-angular';
import {RetrieveEPCsByReaderQuery} from '../../../../shared/graphql/graphql.types';
import {RfidService} from '../../../../identity/services/rfid.service';
import {StockItem} from '../../../../shared/view-model/store-management/stock-item.type';
import {ProductBatchFormComponent} from '../../../product/product-batch-form/product-batch-form.component';
import {FormBuilder, FormGroup} from '@angular/forms';
import {NewAssetsByEpcListComponent} from '../../new-assets-by-epc-list/new-assets-by-epc-list.component';
import {MessageType} from '../../../../shared/redux-store/session';
import * as _ from 'lodash';

@Component({
  selector: 'vb-register-assets-for-article-view',
  templateUrl: './register-assets-for-article-view.component.html',
  styleUrls: ['./register-assets-for-article-view.component.css']
})
export class RegisterAssetsForArticleViewComponent extends AbstractVisbosComponent implements OnInit {

  @ViewChild('assetsList')
  assetsList: NewAssetsByEpcListComponent;

  private readerQuery$: ApolloQueryObservable<RetrieveEPCsByReaderQuery>;

  public epcs: string[] = [];
  public activeArticle: StockItem;
  public assetData;

  productBatchForm: FormGroup;
  productBatch;

  lastManaulEpc;

  constructor(sessionActions: SessionActions, cd: ChangeDetectorRef,
              private route: ActivatedRoute, private fb: FormBuilder,
              private rfidService: RfidService) {
    super(sessionActions, cd);

    this.actions = [
      {
        label: 'Gegenstände via RFID einlesen',
        icon: 'fa-scanner',
        action: () => this.readRFID.apply(this),
        helpText: 'Löst einen RFID-Lesevorgang aus und fügt alle gelesenen RFID-Tags in die Liste der neu anzulegenden Gegenstände hinzu'
      },
      {
        label: 'Gegenstände registrieren',
        icon: 'fa-save',
        action: () => this.registerAssets.apply(this),
        disabled: () => !this.canRegisterAssets.apply(this),
        helpText: 'Registriert alle neu anzulegenden Gegenstände mit den vorgegebenen Stammdaten und EPCs im System',
        disabledText: 'Fügen Sie zuerst neu anzulegende Gegestände in die Liste hinzu'
      }
    ];

  }

  ngOnInit(): void {
    super.ngOnInit();
    this.addSubscription(this.route.data.subscribe(data => {
      this.activeArticle = data.stockItem;
    }));
  }

  addProductBatch() {
    this.productBatchForm = ProductBatchFormComponent.initControl(this.fb);
  }

  removeProductBatch() {
    this.assetsList.removeProductBatchFromAssets();
    this.productBatchForm = null;
  }

  applyProductBatch() {
    this.assetsList.applyProductBatchToAssets(this.productBatchForm);
  }

  onAssetDataChanged(data) {
    this.assetData = data;
  }

  readRFID() {
    this.sessionActions.initAsyncAction();
    if (!this.readerQuery$) {
      this.readerQuery$ = this.rfidService.retrieveEPCsFromReader({readerCuid: this.rfidService.getReaderForMarriage()}, 'network-only');
      this.addComponentData(this.readerQuery$);
      this.addSubscription(this.readerQuery$.subscribe(res => {
        if (!res.loading) {
          this.sessionActions.finishAsyncAction();
        }
        this.addEpcs(res.data.epcsByReader);
      }, err => {
        this.sessionActions.finishAsyncAction();
        this.sessionActions.throwError(err, 'Fehler beim Abrufen der RFID-Daten!', 'RFID-Lesevorgang');
      }));
    } else {
      this.readerQuery$.refetch().then(
        res => {
          if (!res.loading) {
            this.sessionActions.finishAsyncAction();
          }
          this.addEpcs(res.data.epcsByReader);
        }, err => {
          this.sessionActions.finishAsyncAction();
          this.sessionActions.throwError(err, 'Fehler beim Abrufen der RFID-Daten!', 'RFID-Lesevorgang');
        }
      );
    }
  }

  addEpc(epc: string) {
    if (!epc) {
      return;
    }
    this.addEpcs([epc]);
    this.lastManaulEpc = null;
  }

  addEpcs(epcs: string[]) {
    if (!epcs || !epcs.length) {
      return;
    }
    this.epcs = _.uniq([...this.epcs, ...epcs]);
    this.lastManaulEpc = null;
  }

  canRegisterAssets() {
    return this.assetData && this.assetData.length;
  }

  registerAssets() {

    const query$ = this.rfidService.registerAssetsForArticle({
      articleCuid: this.activeArticle.cuid,
      assetsData: this.assetData
    });

    this.addSubscription(query$.subscribe(res => {
      this.sessionActions.pushMessage('Gegenstände wurden erfolgreich registriert!', MessageType.SUCCESS, 'Gegenstandsverwaltung');
      this.epcs = [];
      this.assetData = null;
      this.productBatchForm = null;
    }, err => {
      this.sessionActions.throwError(err, 'Fehler beim Registrieren der Gegenstände! Bitte wenden Sie sich an den Support!', 'Gegenstandsverwaltung');
    }))
  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/asset-management/views/register-assets-for-article-view/register-assets-for-article-view.component.ts